module.exports = __webpack_public_path__ + "static/media/comment-edit.900de3e8.svg";